/*jshint esversion: 6 */
import React, { Component } from 'react';
import '../css/style.css';
import OnlyText from "./OnlyText.js";
import OnlyTextFloatLeft from "./OnlyTextFloatLeft.js";
import OnlyTextFloatRight from "./OnlyTextFloatRight.js";
import  DisplayManus from "../utils/displayManusFile.js";
import * as manusFuncs from "../utils/manusFuncs.js";
import '../css/utils.css';

class Manus extends Component {
  constructor(props){
    super(props);
    this.displayManusRows = this.displayManusRows.bind(this);
  }

  displayManusRows(){
    var manuses = this.props.manuses;
    var keyi = this.props.keyi;
    var templateObj = this.props.templateObj;
    const templateheader = templateObj.header;
    const rows = [];
    // console.log('displayManusRows', manuses);
    let imageClassNames = " image " + " image_" + templateheader + " ";
    let imageContainerClassNames = " image_container " + "image_container_" + templateheader + " ";
    manuses.map((m, mk) => {
        // console.log("ODDEVEN KEYI" , templateheader, typeof(keyi), keyi);
        // console.log("ODDEVEN value" , typeof(mk), mk);
        var isOdd = (keyi%2 === 0);
        // console.log("ODDEVEN isOdd" , isOdd);
        rows.push(
            <div key={mk}  className={"manus_row_" + isOdd + " " + imageContainerClassNames}>
                {m.header? 
                    <div className="manus_header">
                        {m.header}
                    </div>
                :''}
                {m.content? 
                    <div className="manus_content">
                        {m.content}
                    </div>
                :''}

                { <div className={imageContainerClassNames}>
                        <DisplayManus
                            linkstoURl = {m.linkstoURl}
                            templateheader = {templateheader}
                            more = {false}
                            key = {mk}
                            _id = {m._id}
                            originalname = {m.img? m.img.originalname : manusFuncs.getFileNameFromUrl(m.externalUrl)}
                            file = {m.links.file}
                        />
                </div> }

                {m.footer? 
                    <div className={"manus_footer_" + templateheader}>
                        {m.footer}
                    </div>
                :''}
            </div>
        );
    });
    return rows;
  }

    render() {
        //console.log('Manus props', this.props);
        const manusRows = this.displayManusRows();
        var content = this.props.content;
        var header = this.props.header;
        var templateObj = this.props.templateObj;
        var keyi = this.props.keyi;
        //console.log('manus templateObj', templateObj);
        const templateheader = templateObj.header;
        //console.log('manus templateheader', templateheader);
        var isOdd = (keyi%2 === 0);
        return (
          <div className={"manus_container " + " manus_container_" + templateheader}>
          {templateheader === 'cv'?
           <div>
                <div className={"manusRows " + " manusRows_" + templateheader}>
                    {manusRows}
                </div>
                <OnlyTextFloatLeft
                    header = {header}
                    content={content}
                    templateHeader = {templateheader}
                />
            </div>
            :
            (templateheader === 'chess' && isOdd)?
            <div>
                <OnlyText
                    header = {header}
                    content={content}
                    templateHeader = {templateheader}
                />
                <div className={"manusRows " + " manusRows_" + templateheader}>
                    {manusRows}
                </div>
            </div>
             :
             (templateheader === 'chess' && !isOdd)?
             <div>
                 <div className={"manusRows " + " manusRows_" + templateheader}>
                     {manusRows}
                 </div>
                 <OnlyText
                     header = {header}
                     content={content}
                     templateHeader = {templateheader}
                 />
             </div>
            :
            <div>
                <OnlyText
                    header = {header}
                    content={content}
                    templateHeader = {templateheader}
                />
                <div className={"manusRows " + " manusRows_" + templateheader}>
                    {manusRows}
                </div>
            </div>
           }
           <div className="divclear"></div>
          </div>
        );
      }

}

export default Manus;


// WEBPACK FOOTER //
// ./src/Templates/Manus.js